import { NgModule } from '@angular/core'
import { Routes, RouterModule } from '@angular/router'
import { WorkWithUsComponent } from './work-with-us/work-with-us.component'
import { JobOpenningDetailComponent } from './work-with-us/job-openning-detail/job-openning-detail.component'

const routes: Routes = [
  {
    path: '',
    component: WorkWithUsComponent,
  },
  {
    path: 'position/:jobNameUrl',
    component: JobOpenningDetailComponent,
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobRoutingModule {}
